import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
	state: {
		//disabled: false,
		costom: ['bbqf','bbbj','bbgd','bbjz','lldygc','lldysj'],
	},
	// mutations: {
	// 	setDisabled(state, disabled) {
	// 		state.disabled = disabled
	// 	},
	// }
})

export default store



// WEBPACK FOOTER //
// ./src/common/store.js